module.exports = __webpack_public_path__ + "img/first-right.53ba2831.png";